<template lang="pug">
  div(v-cloak).sub-page.heading
    CommonHeader
    main
      v-container.primary--text
        h1 プレスリリース・掲載情報

        h2 プレスリリース
        v-layout.article_title_frame(row wrap v-for='article in pressList', :key='article.title', v-bind='{ [`xs${article.flex}`]: true }')
          v-flex(xs12 md2)
            .article_date_frame
              span(v-text='article.date').primary--text
          v-flex(xs12 md10)
            .article_title
              a(target='_brank', :href='article.to' v-text='article.title')

        h2 掲載情報
        v-layout.article_title_frame(row wrap v-for='article in mediaList', :key='article.title', v-bind='{ [`xs${article.flex}`]: true }')
          v-flex(xs12 md2)
            .article_date_frame.primary--text
              span(v-text='article.date')
          v-flex(xs12 md10)
            .article_title
              a(target='_brank', :href='article.to' v-text='article.title')

    CommonFooter
    span.footer_pic

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
    this.$vuetify.theme.secondary = '#ffcc00'
  },
  data () {
    return {
      pressList: [
        {
          date: '2024/03/28',
          title: 'ニュージーランド生まれ！砂糖・甘味料・着色料不使用。 果汁贅沢アイス『Juicies(ジューシーズ)』から “チェリー”フレーバーが4月1日新発売！',
          to: 'https://www.atpress.ne.jp/news/388718'
        },
        {
          date: '2019/03/22',
          title: 'ニュージーランド発！砂糖・甘味料・着色料不使用。 　果汁贅沢アイス『Juicies(ジューシーズ)』から “ココナッツストロベリー”“アップル”の2フレーバーが 3月22日新発売！',
          to: 'https://gourmetpress.net/131392/'
        },
        {
          date: '2018/06/11',
          title: 'ニュージーランドアイスJuicies専用冷凍庫を期間限定で無料貸出　 観光地や行楽施設におすすめの簡単に動かせるキャスター付き！',
          to: 'https://www.atpress.ne.jp/news/157530'
        },
        {
          date: '2018/03/16',
          title: 'ニュージーランド発！砂糖・甘味料・着色料不使用。果汁贅沢アイス『Juicies(ジューシーズ)』から“ココナッツシリーズ”3月16日新発売！',
          to: 'https://www.atpress.ne.jp/news/150742'
        }, {
          date: '2017/07/18',
          title: 'カロリー40kacl台＆ストレート果汁ベースの贅沢アイス　『Juicies(ジューシーズ)』20万本以上出荷！',
          to: 'https://www.atpress.ne.jp/news/131571'
        }, {
          date: '2017/05/30',
          title: '熱い夏にはニュージーランド発のヘルシーアイス！カロリー40kcal台でフルーツ本来のさわやかな甘み',
          to: 'https://www.atpress.ne.jp/news/129250'
        }, {
          date: '2017/04/27',
          title: 'ニュージーランド発、贅沢フルーツアイス『Juicies』がPLAZAで販売開始！',
          to: 'https://www.atpress.ne.jp/news/127251'
        }, {
          date: '2016/07/14',
          title: 'ニュージーランド発、贅沢フルーツアイス『Juicies』が7月19日(火)asnas アズナスで販売開始！',
          to: 'https://www.atpress.ne.jp/news/106906'
        }, {
          date: '2016/07/12',
          title: '夏のアイスは美味しくヘルシーに！贅沢フルーツアイス『Juicies』全国のデイリーヤマザキで7月12日販売開始',
          to: 'https://www.atpress.ne.jp/news/106789'
        }, {
          date: '2016/06/08',
          title: 'カロリー40kacl台＆ストレート果汁ベースの贅沢アイス　『Juicies(ジューシーズ)』6万5,000本以上出荷！',
          to: 'https://www.atpress.ne.jp/news/103569'
        }, {
          date: '2016/04/26',
          title: 'ニュージーランド発、贅沢フルーツアイス、ジューシーズが4月26日(火)全国のデイリーヤマザキで販売開始！！',
          to: 'https://www.atpress.ne.jp/news/95980'
        }, {
          date: '2016/03/16',
          title: '日本初上陸！りんごストレート果汁94％以上のアイス『Juicies(ジューシーズ)』3月18日販売開始',
          to: 'https://www.atpress.ne.jp/news/94440'
        }
      ],
      mediaList: [
        {
          date: '2017/03/28',
          title: '月刊新潟Komachi5月号'
        }, {
          date: '2016/04/20',
          title: '生協流通新聞 2016年4月20日号'
        }
      ]
    }
  }
}

</script>

<style scoped lang="stylus">

.article_title_frame
  border-bottom 1px solid #ccc
  cursor pointer
  padding 20px 0
  &:hover
    background-color #fdfaf4
  a
    color #666
    text-decoration none
    font-size 0.9rem
  .article_date_frame
    float left
    width 120px
    font-weight bold
    vertical-align middle
    font-size 0.9rem
  .article_title
    vertical-align middle
    display table-cell

//Footer
.footer_pic
  background url(../../../../../static/images/footer_pic_coconuts.png) no-repeat
  background-position bottom 0 right -15px

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Press/index.vue